angular.module('swapick')
.controller('LoginCtrl', LoginCtrl);

function LoginCtrl ($auth, $rootScope, authService, $ionicSideMenuDelegate, DataService, clientId, clientSecret, $http, Entities, $ionicLoading) {


    this.credentials = { 
        username:'', 
        password:'',
        client_id : clientId,
        client_secret : clientSecret,
        grant_type : 'password'
    };

    
    this.login = () =>{
        this.loginError = false

        $ionicLoading.show()
        DataService.getPasswordToken(this.credentials.username, this.credentials.password )
        //$auth.login(this.credentials)
        .then((response) => {
            
            delete $http.defaults.headers.common.Authorization;
            
            Entities.setRefreshToken(response.refresh_token);
            $auth.setToken(response.access_token);
            authService.loginConfirmed();

            $ionicSideMenuDelegate.toggleLeft(false);

            // Redirect user here after a successful log in.
            $rootScope.$broadcast("app:loginSuccess", response);
            //console.info("login success", response);
            this.loginError = false
            setTimeout(() => {
                $ionicLoading.hide()    
            }, 200)
            
            
        })
        .catch((response) => {
            // Handle errors here, such as displaying a notification
            // for invalid email and/or password.
            $rootScope.$broadcast("app:loginError", response);
            authService.loginCancelled();
            //console.error("login error", response);
            $ionicLoading.hide()
            this.loginError = true;
            
        });

    }

  
  
}





// WEBPACK FOOTER //
// ./src/controllers/login-controller.js